import {BaseDataBuilder} from './BaseDataBuilder'

export class BooleanBuilder extends BaseDataBuilder {
    constructor(displayName: string, defaultValue: boolean) {
        super('boolean', displayName, defaultValue)
    }
}
